<template>
  <div>
    <div v-if="isValidResultState">
      <section>
        <div class="group container">
          <div class="row">受付を完了しました。</div>
          <div class="row">
            <div v-if="isValidMailState">ご登録いただいたメールアドレス宛てに，完了連絡を送信いたしました。</div>
            <div v-else>完了連絡メールを送信できませんでした。</div>
          </div>
          <div class="row" v-if="isValidSubmitSeq">【受付番号】{{ submitSeq }}</div>
          <div class="row" v-else>ブラウザの設定により、受付番号を取得できませんでした。</div>
        </div>
        <div class="group container">
          <div class="row">
            <div class="mx-auto">
              <div v-if="$store.getters.isForceEntryMode">
                <router-link tag="button" class="btn btn-lg btn-secondary" to="/entry/step1">入力画面に戻る</router-link>
              </div>
              <div v-else>
                <router-link tag="button" class="btn btn-lg btn-secondary" to="/">受付ページTOPへ</router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <section>
        <div class="group container">
          <div class="row">エラーにより登録できませんでした。</div>
          <div class="row">エラー番号：{{ resultState }}</div>
          <div class="row">{{ errMessage }}</div>
        </div>
        <div class="group container">
          <div class="row">
            <div class="mx-auto">
              <router-link tag="button" class="btn btn-lg btn-secondary" to="/">受付ページTOPへ</router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import err from '@/err'

export default {
  name: 'EntryResult',
  computed: {
    submitResult() {
      return this.$store.getters['entry/submitResult']
    },
    resultState() {
      return this.submitResult.state
    },
    isValidResultState() {
      return this.resultState == err.OK
    },
    isValidMailState() {
      return this.submitResult.mailState === err.OK
    },
    submitSeq() {
      return this.submitResult.seq
    },
    isValidSubmitSeq() {
      return this.submitSeq != ""
    },
    errMessage() {
      return err.desc[this.resultState] || ''
    }
  },
  mounted() {
    document.getElementById('html').scrollTop = 0
    if (this.isValidResultState) {
      this.$store.dispatch("entry/clearInitialEntryToken")
    }
  }
}
</script>
